module.exports = __webpack_public_path__ + "static/media/arteeoartista-partitura-1.781e6724.png";